import { render, staticRenderFns } from "./AppBtn.vue?vue&type=template&id=3348453f&"
import script from "./AppBtn.vue?vue&type=script&lang=js&"
export * from "./AppBtn.vue?vue&type=script&lang=js&"
import style0 from "./AppBtn.vue?vue&type=style&index=0&id=3348453f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports